import '../../utils/style-new-business.css';
import { Col, Row, Card } from "reactstrap";
import { FilePdfTwoTone, PictureOutlined } from "@ant-design/icons";
import FormatFileSize from "../../../../../common/format/file";
import { countryInfo } from "./PaymentMethodSelector";

const RecapForm = ({ formData, logo, documents }) => {

   const documentList = documents
    ? [
        { label: "Registre du commerce", file: documents.businessRegistryFileName },
        { label: "Ninéa", file: documents.nineaFileName },
        { label: "Document Statut", file: documents.statutFileName },
      ]
    : [];

  return (
    <div>
      <h5 className="title-addEdit-Step">Récapitulatif</h5>

      <Card className="recap-card">
        <h6>Informations basiques</h6>
        <Row className="recap-info-container">
          <div className="dev-logo-upload-container">
            <div className="dev-logo-placeholder">
              {logo ? (
                <img
                  className="dev-logo-placeholder-img"
                  src={logo}
                  alt="Logo"
                />
              ) : (
                <PictureOutlined className="dev-logo-icon" />
              )}
            </div>
          </div>

          <Col lg={12}>
            <p className="recap-description-title">Description</p>
            <p className="recap-description">{formData.description}</p>
          </Col>
        </Row>

        <table className="recap-table">
          <thead>
            <tr>
              <th>Business</th>
              <th>Type</th>
              <th>Pays</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{formData.businessName}</td>
              <td>
                {formData.type === "COMPANY"
                  ? "Entreprise"
                  : formData.type === "PARTICULAR"
                  ? "Particulier"
                  : "Autre"}
              </td>
              <td>{formData.country}</td>
            </tr>
          </tbody>
        </table>
      </Card>

      <Card className="recap-card">
        <h6>Méthodes de paiement</h6>
        <div className="detail-div mb-4">
          {formData.countryPaymentMethods.length > 0 ? (
            <table className="recap-table">
              <thead>
                <tr>
                  <th>Pays</th>
                  <th>Nom</th>
                  <th>Devise</th>
                  <th>Préfixe</th>
                </tr>
              </thead>
              <tbody>
                {formData.countryPaymentMethods.flatMap((block) =>
                  block.paymentMethods?.map((method, i) => (
                    <tr key={`${block.country}-${i}`}>
                      <td>
                        {countryInfo[block.country]?.flag && (
                          <img
                            src={countryInfo[block.country].flag}
                            alt={countryInfo[block.country].name}
                            style={{ width: 20, marginRight: 6, display: "inline-block", verticalAlign: "middle" }}
                          />
                        )}
                        {countryInfo[block.country]?.name || block.country}
                      </td>
                      <td>{method.name || "-"}</td>
                      <td>{method.currency || "-"}</td>
                      <td>+{method.prefixCode || "-"}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          ) : (
            <Row>
              <Col lg={12}>Aucune méthode de paiement disponible</Col>
            </Row>
          )}
        </div>
      </Card>

      <Card className="recap-card">
        <h6>Documents requis</h6>
        <Row>
          {documentList.length > 0 ? (
            documentList.map((doc, idx) => (
              <Col lg={4} >
                <div className="document-card" key={idx} style={{ height: "100%"}}>
                  {doc.file ? (
                    <>
                    <p className="document-title">{doc.label}</p>
                    <FilePdfTwoTone
                      twoToneColor="red"
                      style={{ fontSize: "48px", marginBottom: "10px" }}
                    />
                    <br />
                    <strong>Nom </strong>: {doc.file.name || "Pas de nom"}
                    <br />
                    <strong>Taille </strong>: {FormatFileSize(doc.file.size)}
                  </>
                  ) : (
                    <p>Aucun document téléchargé pour le {doc.label}</p>
                  )}
                </div>
              </Col>
            ))
          ) : (
            <Col lg={12}>Aucun document téléchargé.</Col>
          )}
        </Row>
      </Card>
    </div>
  );
};

export default RecapForm;
